module.exports = __webpack_public_path__ + "img/s8.f6598f96.png";